import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=fb4d5c40&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=js&"
export * from "./Investigation.vue?vue&type=script&lang=js&"
import style0 from "./Investigation.vue?vue&type=style&index=0&id=fb4d5c40&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4d5c40",
  null
  
)

export default component.exports